<template>
  <vx-card id="announcements" class="vs-con-loading__container" title="الإعلانات">
    <div v-if="canControl" slot="actions">
      <vs-button @click="isAnnouncementFormActive = true" class="rounded-full" icon="icon-plus" icon-pack="feather" icon-after>اعلان</vs-button>
    </div>
    <VuePerfectScrollbar class="relative border border-solid rounded-lg d-theme-border-grey-light h-150" :settings="settings">
      <div v-if="announcements.length > 0">
        <div v-for="(announcement) in announcementsSort" :key="announcement.id"
             class="p-4 border border-solid border-t-0 border-l-0 border-r-0 last:border-b-0 d-theme-border-grey-light">
          <div class="flex items-center justify-between">
            <h5>{{ announcement.title }}</h5>
            <feather-icon v-if="canControl" @click="deleteAnnouncement(announcement.id)" icon="TrashIcon" svg-classes="h-5 w-5 hover:text-danger cursor-pointer"/>
          </div>
          <p class="mb-4 mt-1">
            <span v-if="!$route.params.course_id"> {{ courses[announcement.course_id].name }} </span>
            المجموعة ({{ announcement.groups.join(', ') }})
          </p>
          <p>{{ announcement.message }}</p>
          <p class="mt-1 text-gray flex items-center">
            <feather-icon icon="CalendarIcon" svg-classes="h-4 w-4 mr-2" />
            {{ announcement.time | date(true) }}
          </p>
        </div>
      </div>
      <div class="p-4 mt-16" v-else>
        <vs-icon class="mb-base block m-auto shadow-md rounded-full p-8 w-32 h-32 flex items-center justify-center " size="3rem" icon-pack="fas" icon="fa-bullhorn"></vs-icon>
        <h2 class="text-left text-primary mb-2">لا يوجد إعلانات</h2>
        <h5 class="text-left">
          <span>قم بالتحقق لاحقاً عندما يتم بإضافة إعلان.</span>
        </h5>
      </div>
    </VuePerfectScrollbar>
    <announcement-form v-if="canControl" @save="saveAnnouncement" :active.sync="isAnnouncementFormActive"/>
  </vx-card>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import AnnouncementForm from '@/views/components/announcements/AnnouncementForm'
    import announcementAPI from '@/api/announcementAPI'

    export default {
        components: { AnnouncementForm, VuePerfectScrollbar },
        name: 'Announcements',
        data () {
            return {
                announcements: [],
                settings: {
                    maxScrollbarLength: 60,
                    wheelPropagation: true,
                },
                isAnnouncementFormActive: false,
            }
        },
        computed: {
            canControl(){
                return this.isTeacher && this.$route.params.course_id
            },
            courses() {
                return this.$store.state.courses.all
            },
            announcementsSort() {
                return this.announcements.slice().sort((a, b) => {
                    return new Date(b.time) - new Date(a.time)
                })
            }
        },
        watch: {
            '$route.params'(oldVal, val){
                if(oldVal.course_id !== val.course_id){
                    this.loadData()
                }
            }
        },
        methods: {
            saveAnnouncement(announcement) {
                this.announcements.unshift(announcement)
            },
            deleteAnnouncement(id){
                this.$confirmAlert(null, 'هل انت متأكد من حذف هذا الإعلان؟', () => {
                    this.$startLoading('#announcements')
                    announcementAPI.delete(id, this.$route.params.course_id)
                        .then(() => {
                            const index = this.announcements.findIndex(ann => ann.id === id )
                            this.$delete(this.announcements, index)
                        })
                        .catch(error => this.$notifyError(error.statusMessage))
                        .finally(() => this.$closeLoading('#announcements'))
                })
            },
            loadData() {
                this.announcements = []
                this.$startLoading('#announcements')
                const announcementRequest = this.$route.params.course_id ?
                    announcementAPI.getAllByCourse(this.$route.params.course_id) :
                    announcementAPI.getAll()

                announcementRequest
                    .then(({data}) => {this.announcements = data.announcements})
                    .finally(() => this.$closeLoading('#announcements'))
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>
